async function sendDownloadLinkEmail(resourceId, customerId) {
  const baseUrl = 'https://app.editionguard.com'; // Replace with the actual EditionGuard base URL
  const url = `${baseUrl}/api/v2/deliver-book-link`;
  const token = '0fe786576da1a9c50b64c510b40b1b99352828e2'; // Replace with your actual EditionGuard API token

  // Retrieve email from Shopify
  const email = await getEmailFromShopify(customerId);

  const data = {
    email: email,
    resource_id: resourceId
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error('Failed to send download link email');
    }

    return response.json(); // Return JSON response if necessary
  } catch (error) {
    console.error('Error sending download link email:', error.message);
    throw error;
  }
}

async function getEmailFromShopify(customerId) {
  const shopifyBaseUrl = 'https://f744b6.myshopify.com/'; // Replace with your Shopify store URL
  const token = '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'; // Replace with your actual Shopify API access token

  const customerUrl = `${shopifyBaseUrl}/admin/api/2021-10/customers/${customerId}.json`;

  try {
    const response = await fetch(customerUrl, {
      headers: {
        'X-Shopify-Access-Token': token
      }
    });

    if (!response.ok) {
      throw new Error('Failed to retrieve customer details');
    }

    const customerData = await response.json();
    const email = customerData.customer.email;

    return email;
  } catch (error) {
    console.error('Error retrieving customer email:', error.message);
    throw error;
  }
}

